/**
 * BEST SELLERS SECTION - JAVASCRIPT FUNCTIONALITY
 * Handles filter buttons, horizontal scrolling, and touch gestures
 */

(function() {
  function initOne(sectionEl) {
  if (!sectionEl) return;
  const filterBtns = Array.from(sectionEl.querySelectorAll('.filter-btn'));
  const collectionTabs = Array.from(sectionEl.querySelectorAll('.collection-tab'));
  const filtersContainer = sectionEl.querySelector('.best-sellers-filters');
  const scrollbar = sectionEl.querySelector('.best-sellers-scrollbar');
  const scrollbarTrack = sectionEl.querySelector('.best-sellers-scrollbar-track');
  const scrollbarFill = sectionEl.querySelector('.best-sellers-scrollbar-fill');
  const scrollbarThumb = sectionEl.querySelector('.best-sellers-scrollbar-thumb');
  
  // Utility: set active tab/panel with ARIA updates
  function setActiveTabByCollection(collectionHandle) {
    const productsContainer = sectionEl.querySelector('#products-container');
    // Update buttons
    filterBtns.forEach(btn => {
      const isTarget = btn.getAttribute('data-collection') === collectionHandle;
      btn.classList.toggle('active', isTarget);
      btn.setAttribute('aria-selected', String(isTarget));
      btn.tabIndex = isTarget ? 0 : -1;
    });

    // Update panels
    collectionTabs.forEach(panel => {
      const isTarget = panel.getAttribute('data-collection') === collectionHandle;
      panel.classList.toggle('active', isTarget);
      panel.setAttribute('aria-hidden', String(!isTarget));
    });

    // Reset scroll to start and focus container for keyboard users
    if (productsContainer) {
      productsContainer.scrollTo({ left: 0, behavior: 'smooth' });
      // Update scrollbar after scroll reset
      window.requestAnimationFrame(updateScrollbar);
    }
  }

  // Filter button functionality (click activates panel)
  filterBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetCollection = this.getAttribute('data-collection');
      setActiveTabByCollection(targetCollection);
    });
  });

  // Initialize roving tabindex: ensure only the active has tabIndex 0
  (function initTabsRovingTabindex() {
    const activeBtn = document.querySelector('.filter-btn.active') || filterBtns[0];
    filterBtns.forEach(btn => {
      const isActive = btn === activeBtn;
      btn.tabIndex = isActive ? 0 : -1;
      btn.setAttribute('aria-selected', String(isActive));
    });
  })();

  // Keyboard navigation for tabs per ARIA practices
  if (filtersContainer) {
    filtersContainer.addEventListener('keydown', (e) => {
      const key = e.key;
      const currentIndex = filterBtns.findIndex(b => b.tabIndex === 0);
      if (currentIndex === -1) return;

      let nextIndex = null;
      if (key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % filterBtns.length;
      } else if (key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + filterBtns.length) % filterBtns.length;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = filterBtns.length - 1;
      } else if (key === 'Enter' || key === ' ') {
        // Activate current
        const current = filterBtns[currentIndex];
        current.click();
        e.preventDefault();
        return;
      }

      if (nextIndex !== null) {
        e.preventDefault();
        const next = filterBtns[nextIndex];
        // Move focus only (roving tabindex)
        filterBtns.forEach((b, i) => b.tabIndex = i === nextIndex ? 0 : -1);
        next.focus();
      }
    });
  }
  
  // Horizontal scrolling for products
  const container = sectionEl.querySelector('#products-container');
  const prevBtn = sectionEl.querySelector('.best-sellers-nav .best-sellers-button.prev');
  const nextBtn = sectionEl.querySelector('.best-sellers-nav .best-sellers-button.next');
  
  // Compute scroll amount based on first visible card width + gap
  function getScrollAmount() {
    const activePanel = document.querySelector('.collection-tab.active');
    if (!activePanel) return 300;
    const firstItem = activePanel.querySelector('.best-sellers-product-item');
    if (!firstItem) return 300;
    const itemWidth = Math.ceil(firstItem.getBoundingClientRect().width);
    let gap = 20;
    try {
      const cs = window.getComputedStyle(activePanel);
      const g = cs.gap || cs.columnGap || '20px';
      gap = Math.round(parseFloat(g));
      if (Number.isNaN(gap)) gap = 20;
    } catch (e) {
      gap = 20;
    }
    return itemWidth + gap;
  }
  
  if (container && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      window.requestAnimationFrame(updateScrollbar);
    });
    nextBtn.addEventListener('click', () => {
      container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      window.requestAnimationFrame(updateScrollbar);
    });
    // Keyboard support when container focused
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        window.requestAnimationFrame(updateScrollbar);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        window.requestAnimationFrame(updateScrollbar);
      }
    });
  }

  // Update scrollbar continuously on scroll and on resize whenever container exists
  if (container) {
    container.addEventListener('scroll', () => {
      updateScrollbar();
    });

    // Optional: hold Shift to map wheel to horizontal without blocking page vertical scroll
    container.addEventListener('wheel', (e) => {
      if (!e.shiftKey) return; // preserve normal vertical page scroll
      const absX = Math.abs(e.deltaX);
      const absY = Math.abs(e.deltaY);
      const delta = absX > absY ? e.deltaX : e.deltaY;
      e.preventDefault();
      container.scrollBy({ left: delta, behavior: 'auto' });
      updateScrollbar();
    }, { passive: false });
  }

  // Also map wheel on the wrapper so users don't have to be exactly over the grid
  const wrapper = sectionEl.querySelector('.best-sellers-products-wrapper');
  if (wrapper && container) {
    wrapper.addEventListener('wheel', (e) => {
      if (!e.shiftKey) return; // only when Shift is held
      const absX = Math.abs(e.deltaX);
      const absY = Math.abs(e.deltaY);
      const delta = absX > absY ? e.deltaX : e.deltaY;
      e.preventDefault();
      container.scrollBy({ left: delta, behavior: 'auto' });
      updateScrollbar();
    }, { passive: false });
  }
  window.addEventListener('resize', () => {
    updateScrollbar();
  });

  // Initial updates after DOM ready, next tick, and window load (images/font impact)
  updateScrollbar();
  setTimeout(updateScrollbar, 0);
  window.addEventListener('load', updateScrollbar, { once: true });

  // Custom scrollbar logic - Optimized to avoid forced reflows
  // Batches all DOM reads first, then all DOM writes to prevent layout thrashing
  function updateScrollbar() {
    if (!container || !scrollbar || !scrollbarTrack || !scrollbarThumb) return;
    
    // ===== PHASE 1: BATCH ALL DOM READS (no forced reflows) =====
    const totalWidth = container.scrollWidth;
    const viewport = container.clientWidth;
    const scrollLeft = container.scrollLeft;
    const trackWidth = scrollbarTrack.getBoundingClientRect().width;
    
    // Calculate all values based on reads
    const maxScroll = Math.max(totalWidth - viewport, 0);
    const hasOverflow = maxScroll > 0;
    
    // Early exit check - still batching reads before writes
    if (trackWidth <= 0 || viewport <= 0 || totalWidth <= 0) {
      // ===== PHASE 2: BATCH ALL DOM WRITES =====
      scrollbarThumb.style.transform = 'translateX(0)';
      if (scrollbarFill) scrollbarFill.style.width = '0px';
      return;
    }
    
    // Calculate thumb dimensions and position
    const visibleRatio = Math.min(viewport / totalWidth, 1);
    const thumbWidth = Math.max(Math.round(trackWidth * visibleRatio), 40);
    const leftRatio = maxScroll === 0 ? 0 : scrollLeft / maxScroll;
    const maxThumbOffset = Math.max(trackWidth - thumbWidth, 0);
    const thumbLeft = Math.round(maxThumbOffset * leftRatio);
    
    // Calculate fill width
    const rightRatio = Math.min((scrollLeft + viewport) / totalWidth, 1);
    const fillWidth = Math.round(trackWidth * rightRatio);
    
    // ===== PHASE 2: BATCH ALL DOM WRITES (no forced reflows) =====
    // All calculations done, now apply all style changes together
    scrollbarThumb.style.width = thumbWidth + 'px';
    scrollbarThumb.style.transform = `translateX(${thumbLeft}px)`;
    scrollbarThumb.style.left = `${thumbLeft}px`;
    
    if (scrollbarFill) {
      scrollbarFill.style.width = `${fillWidth}px`;
    }
    
    scrollbar.style.opacity = hasOverflow ? '1' : '0';

    // Update nav button disabled states
    if (prevBtn) {
      const atStart = scrollLeft <= 0;
      prevBtn.disabled = atStart;
      prevBtn.classList.toggle('disabled', atStart);
    }
    if (nextBtn) {
      const atEnd = scrollLeft >= (maxScroll - 1);
      nextBtn.disabled = atEnd || !hasOverflow;
      nextBtn.classList.toggle('disabled', atEnd || !hasOverflow);
    }
  }

  // Initialize scrollbar after DOM is ready
  updateScrollbar();
  
  // Touch/swipe gestures for mobile
  let touchStartX = 0;
  let touchStartY = 0;
  let isScrolling = null;
  
  if (container) {
    container.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isScrolling = null;
    }, { passive: true });
    
    container.addEventListener('touchmove', function(e) {
      if (!touchStartX || !touchStartY) return;
      
      const touchEndX = e.touches[0].clientX;
      const touchEndY = e.touches[0].clientY;
      const diffX = touchStartX - touchEndX;
      const diffY = touchStartY - touchEndY;
      
      if (isScrolling === null) {
        isScrolling = Math.abs(diffX) > Math.abs(diffY);
      }
      
      // If horizontal scrolling, prevent vertical scroll
      if (isScrolling && Math.abs(diffX) > 10) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  // ============================================
  // LAZY LOADING FOR PRODUCTS (First 8 immediate, rest deferred)
  // ============================================
  function initLazyProducts() {
    const productsContainer = sectionEl.querySelector('#products-container');
    if (!productsContainer) return;

    const lazyProducts = sectionEl.querySelectorAll('[data-lazy-product="true"]');
    if (lazyProducts.length === 0) return;

    // Track which products have been revealed
    const revealedProducts = new Set();

    function revealProduct(product) {
      if (revealedProducts.has(product)) return;
      
      revealedProducts.add(product);
      product.style.visibility = 'visible';
      product.removeAttribute('data-lazy-product');
      
      // Smooth fade-in animation
      product.style.opacity = '0';
      product.style.transition = 'opacity 0.3s ease-in-out';
      requestAnimationFrame(() => {
        product.style.opacity = '1';
      });
    }

    // Strategy 1: Use Intersection Observer for viewport-based lazy loading
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            revealProduct(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: productsContainer,
        rootMargin: '400px', // Load 400px before coming into view
        threshold: 0.01
      });

      lazyProducts.forEach(product => {
        observer.observe(product);
      });

      // Strategy 2: Also reveal products on scroll/interaction
      let revealTimeout;
      const revealOnScroll = () => {
        clearTimeout(revealTimeout);
        revealTimeout = setTimeout(() => {
          // Reveal next batch of products when user is actively scrolling
          const unrevealed = sectionEl.querySelectorAll('[data-lazy-product="true"]');
          const batchSize = Math.min(4, unrevealed.length); // Reveal 4 at a time
          for (let i = 0; i < batchSize; i++) {
            if (unrevealed[i]) {
              revealProduct(unrevealed[i]);
            }
          }
        }, 200);
      };

      productsContainer.addEventListener('scroll', revealOnScroll, { passive: true });
      
      // Strategy 3: Reveal all on filter change (when user switches tabs)
      filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          setTimeout(() => {
            const activeTab = sectionEl.querySelector('.collection-tab.active');
            if (activeTab) {
              const tabLazyProducts = activeTab.querySelectorAll('[data-lazy-product="true"]');
              // Reveal first 16 products immediately when switching tabs
              const revealCount = Math.min(16, tabLazyProducts.length);
              for (let i = 0; i < revealCount; i++) {
                if (tabLazyProducts[i]) {
                  revealProduct(tabLazyProducts[i]);
                }
              }
            }
          }, 100);
        });
      });

    } else {
      // Fallback: reveal all immediately if no IntersectionObserver
      lazyProducts.forEach(product => revealProduct(product));
    }
  }

  // Initialize lazy loading
  initLazyProducts();

  }
  function initAll() {
    const sections = document.querySelectorAll('.best-sellers-section');
    sections.forEach((el) => initOne(el));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
